export default __webpack_public_path__ + "static/media/InfoWarning.7ab8c366.svg";